/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DiagnoseSurveyCto } from '../models/diagnose-survey-cto';
import { DiagnoseSurveyTakerCto } from '../models/diagnose-survey-taker-cto';
import { getSurveysByCompanyGuidAsync$Json } from '../fn/diagnose-survey-actions/get-surveys-by-company-guid-async-json';
import { GetSurveysByCompanyGuidAsync$Json$Params } from '../fn/diagnose-survey-actions/get-surveys-by-company-guid-async-json';
import { getSurveysByCompanyGuidAsync$Plain } from '../fn/diagnose-survey-actions/get-surveys-by-company-guid-async-plain';
import { GetSurveysByCompanyGuidAsync$Plain$Params } from '../fn/diagnose-survey-actions/get-surveys-by-company-guid-async-plain';
import { getSurveysByCompanyIdAsync$Json } from '../fn/diagnose-survey-actions/get-surveys-by-company-id-async-json';
import { GetSurveysByCompanyIdAsync$Json$Params } from '../fn/diagnose-survey-actions/get-surveys-by-company-id-async-json';
import { getSurveysByCompanyIdAsync$Plain } from '../fn/diagnose-survey-actions/get-surveys-by-company-id-async-plain';
import { GetSurveysByCompanyIdAsync$Plain$Params } from '../fn/diagnose-survey-actions/get-surveys-by-company-id-async-plain';
import { getSurveyTakersAsync$Json } from '../fn/diagnose-survey-actions/get-survey-takers-async-json';
import { GetSurveyTakersAsync$Json$Params } from '../fn/diagnose-survey-actions/get-survey-takers-async-json';
import { getSurveyTakersAsync$Plain } from '../fn/diagnose-survey-actions/get-survey-takers-async-plain';
import { GetSurveyTakersAsync$Plain$Params } from '../fn/diagnose-survey-actions/get-survey-takers-async-plain';
import { updateTakerEmailAsync$Json } from '../fn/diagnose-survey-actions/update-taker-email-async-json';
import { UpdateTakerEmailAsync$Json$Params } from '../fn/diagnose-survey-actions/update-taker-email-async-json';
import { updateTakerEmailAsync$Plain } from '../fn/diagnose-survey-actions/update-taker-email-async-plain';
import { UpdateTakerEmailAsync$Plain$Params } from '../fn/diagnose-survey-actions/update-taker-email-async-plain';

@Injectable({ providedIn: 'root' })
export class DiagnoseSurveyActionsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSurveysByCompanyIdAsync()` */
  static readonly GetSurveysByCompanyIdAsyncPath = '/diagnose/xp-survey-actions/company-id/{companyId}/surveys';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveysByCompanyIdAsync$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveysByCompanyIdAsync$Plain$Response(params: GetSurveysByCompanyIdAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DiagnoseSurveyCto>>> {
    return getSurveysByCompanyIdAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveysByCompanyIdAsync$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveysByCompanyIdAsync$Plain(params: GetSurveysByCompanyIdAsync$Plain$Params, context?: HttpContext): Observable<Array<DiagnoseSurveyCto>> {
    return this.getSurveysByCompanyIdAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DiagnoseSurveyCto>>): Array<DiagnoseSurveyCto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveysByCompanyIdAsync$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveysByCompanyIdAsync$Json$Response(params: GetSurveysByCompanyIdAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DiagnoseSurveyCto>>> {
    return getSurveysByCompanyIdAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveysByCompanyIdAsync$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveysByCompanyIdAsync$Json(params: GetSurveysByCompanyIdAsync$Json$Params, context?: HttpContext): Observable<Array<DiagnoseSurveyCto>> {
    return this.getSurveysByCompanyIdAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DiagnoseSurveyCto>>): Array<DiagnoseSurveyCto> => r.body)
    );
  }

  /** Path part for operation `getSurveysByCompanyGuidAsync()` */
  static readonly GetSurveysByCompanyGuidAsyncPath = '/diagnose/xp-survey-actions/company/{companyGuid}/surveys';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveysByCompanyGuidAsync$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveysByCompanyGuidAsync$Plain$Response(params: GetSurveysByCompanyGuidAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DiagnoseSurveyCto>>> {
    return getSurveysByCompanyGuidAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveysByCompanyGuidAsync$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveysByCompanyGuidAsync$Plain(params: GetSurveysByCompanyGuidAsync$Plain$Params, context?: HttpContext): Observable<Array<DiagnoseSurveyCto>> {
    return this.getSurveysByCompanyGuidAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DiagnoseSurveyCto>>): Array<DiagnoseSurveyCto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveysByCompanyGuidAsync$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveysByCompanyGuidAsync$Json$Response(params: GetSurveysByCompanyGuidAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DiagnoseSurveyCto>>> {
    return getSurveysByCompanyGuidAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveysByCompanyGuidAsync$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveysByCompanyGuidAsync$Json(params: GetSurveysByCompanyGuidAsync$Json$Params, context?: HttpContext): Observable<Array<DiagnoseSurveyCto>> {
    return this.getSurveysByCompanyGuidAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DiagnoseSurveyCto>>): Array<DiagnoseSurveyCto> => r.body)
    );
  }

  /** Path part for operation `getSurveyTakersAsync()` */
  static readonly GetSurveyTakersAsyncPath = '/diagnose/xp-survey-actions/company/{companyGuid}/surveys/{surveyId}/takers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveyTakersAsync$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyTakersAsync$Plain$Response(params: GetSurveyTakersAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DiagnoseSurveyTakerCto>>> {
    return getSurveyTakersAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveyTakersAsync$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyTakersAsync$Plain(params: GetSurveyTakersAsync$Plain$Params, context?: HttpContext): Observable<Array<DiagnoseSurveyTakerCto>> {
    return this.getSurveyTakersAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DiagnoseSurveyTakerCto>>): Array<DiagnoseSurveyTakerCto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveyTakersAsync$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyTakersAsync$Json$Response(params: GetSurveyTakersAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DiagnoseSurveyTakerCto>>> {
    return getSurveyTakersAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveyTakersAsync$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyTakersAsync$Json(params: GetSurveyTakersAsync$Json$Params, context?: HttpContext): Observable<Array<DiagnoseSurveyTakerCto>> {
    return this.getSurveyTakersAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DiagnoseSurveyTakerCto>>): Array<DiagnoseSurveyTakerCto> => r.body)
    );
  }

  /** Path part for operation `updateTakerEmailAsync()` */
  static readonly UpdateTakerEmailAsyncPath = '/diagnose/xp-survey-actions/company/{companyGuid}/takers/{documentId}/email';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTakerEmailAsync$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateTakerEmailAsync$Plain$Response(params: UpdateTakerEmailAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DiagnoseSurveyTakerCto>> {
    return updateTakerEmailAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTakerEmailAsync$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateTakerEmailAsync$Plain(params: UpdateTakerEmailAsync$Plain$Params, context?: HttpContext): Observable<DiagnoseSurveyTakerCto> {
    return this.updateTakerEmailAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DiagnoseSurveyTakerCto>): DiagnoseSurveyTakerCto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTakerEmailAsync$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateTakerEmailAsync$Json$Response(params: UpdateTakerEmailAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<DiagnoseSurveyTakerCto>> {
    return updateTakerEmailAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTakerEmailAsync$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateTakerEmailAsync$Json(params: UpdateTakerEmailAsync$Json$Params, context?: HttpContext): Observable<DiagnoseSurveyTakerCto> {
    return this.updateTakerEmailAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<DiagnoseSurveyTakerCto>): DiagnoseSurveyTakerCto => r.body)
    );
  }

}
